<div class="widget-loader">
  <div class="ui active dimmer" [ngClass]="{ inverted : addInvertedClass }">
    <div class="ui loader"></div>
  </div>
</div>
